import React from "react";
import "./FleetCoreFuelIntelligenceAnomalyDetection.css";

import fleetcoreFuelIntelligenceAnomalyDetectionDashboardDesktop from "../../images/fleetcore-fuel-intelligence-anomaly-detection-dashboard-desktop.svg";
import fleetcoreFuelIntelligenceAnomalyDetectionDashboardMobile from "../../images/fleetcore-fuel-intelligence-anomaly-detection-dashboard-mobile.svg";

export default function FleetCoreFuelIntelligenceAnomalyDetection() {
  return (
    <section className="fleetcore-fuel-intelligence-anomaly-detection" id="fleetcore-fuel-intelligence" aria-labelledby="fleetcore-fuel-intelligence-anomaly-detection-title">
      <div className="fleetcore-fuel-intelligence-anomaly-detection__inner">
        <div className="fleetcore-fuel-intelligence-anomaly-detection__copy">
          <p className="fleetcore-fuel-intelligence-anomaly-detection__eyebrow">FROM RECORDS TO INTELLIGENCE</p>
          <h2 id="fleetcore-fuel-intelligence-anomaly-detection-title">Find the litres that do not make operational sense.</h2>
          <p className="fleetcore-fuel-intelligence-anomaly-detection__body">FleetCore compares distance or hours against fuel added, vehicle type and operating history—then surfaces exceptions with the underlying evidence still attached.</p>
        </div>
        <picture className="fleetcore-fuel-intelligence-anomaly-detection__dashboard">
          <source media="(max-width: 699px)" srcSet={fleetcoreFuelIntelligenceAnomalyDetectionDashboardMobile} />
          <img src={fleetcoreFuelIntelligenceAnomalyDetectionDashboardDesktop} alt="FleetCore fuel intelligence dashboard showing an illustrative consumption exception and linked evidence" />
        </picture>
        <div className="fleetcore-fuel-intelligence-anomaly-detection__guardrail">
          <strong>Anomaly flagged. Evidence preserved. Management decides.</strong>
          <span>FleetCore surfaces exceptions; it does not issue automatic fraud verdicts.</span>
        </div>
      </div>
    </section>
  );
}